import MinimalLayout from 'layout/MinimalLayout';
import PlayGame from 'views/main';

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <PlayGame />
    }
  ]
};

export default MainRoutes;
